import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetAIPersonUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (query: any, type: string, params: string): Promise<any> => {
        return await this._aiRepository.getAIPerson(query, type, params);
    }
}

export const GetAIPersonUseCaseName = "GetAIPersonUseCaseName";